// CUSTOM FILE (Jess) — not part of stock Dawn.
// Shows a confirm() popup summarizing selected variants before add-to-cart,
// only for products tagged "require-variant-selection".
// Loaded from sections/main-product.liquid.
function initializeProductValidation() {
  const productForm = document.querySelector('product-form.product-form');
  if (!productForm) {
    return;
  }
  
  // This now uses your specific tag.
  const validationTag = 'require-variant-selection';
  
  // Get the product tags that we passed from the liquid file.
  const productTags = JSON.parse(productForm.dataset.productTags || '[]');

  // ONLY run the validation logic if the product has the special tag.
  if (productTags.includes(validationTag)) {
    const submitButton = productForm.querySelector('button[type="submit"]');
    if (!submitButton) {
      return;
    }

    submitButton.addEventListener('click', function(event) {
      const selectedOptions = [];
      const optionPickers = productForm.querySelectorAll('.product-form__input');

      optionPickers.forEach(picker => {
        const optionName = picker.querySelector('label, legend')?.textContent.trim();
        const selectedValue = picker.querySelector('input:checked')?.value || picker.querySelector('select')?.value;

        if (optionName && selectedValue) {
          selectedOptions.push(`${optionName}: ${selectedValue}`);
        }
      });

      const confirmationMessage = `Please confirm the size and color that is selected is correct to add to cart!\n\n${selectedOptions.join('\n')}`;

      if (!confirm(confirmationMessage)) {
        event.preventDefault(); // Stop the item from being added to the cart
      }
    });
  }
}

// Wait for the page to be ready before running the code
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductValidation);
} else {
    initializeProductValidation();
}